import { Component, OnInit,  signal, ChangeDetectionStrategy, ElementRef, ViewChild} from '@angular/core';
import { PaymentUtilitiesService, Module } from '../payment-utilities.service';
import { GridService } from 'app/services/grid.service';
import { TranslocoPipe } from '@ngneat/transloco';
import { IconsModule, SVGIcon } from '@progress/kendo-angular-icons';
import { trashIcon } from '@progress/kendo-svg-icons';
import { CommonModule } from '@angular/common';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { Router } from '@angular/router';
import {MatExpansionModule} from '@angular/material/expansion';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {FormControl, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {firstValueFrom, merge} from 'rxjs';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AuthService } from 'app/core/auth/auth.service';
import { DateTime } from 'luxon';
import { Transaction } from '@progress/kendo-angular-editor';

interface Licenses {
  Title: string;
  DomCode: any;
  DateStart: string;
  DateEnd: string;
  UserStatus: string;
 // SystemStatus: string;
  NexiContractNumber: string;
}

interface Transactions {
  Title: string;
  DomCode: string;
  LicenseCode: string;
  TransactionDate: string;
  TransactionAmount: number;
  PaymentType: string;
  DiscountCode: string;
  NexiTransactionCode: string;
  Description: string;
} 

interface LicenseModules{
  Title: string;
  DomCode: any;
  LicenseCode: string;
  ModuleCode: string;
  DateStart: string;
  DateEnd: string;
  PlanCode: string;
  DateExpired: string;
}

@Component({
  selector: 'app-module-payment',
  standalone: true,
  imports: [    
      CommonModule, 
      TranslocoPipe, 
      ButtonsModule,
      IconsModule,
      MatExpansionModule, 
      MatFormFieldModule, 
      MatInputModule, 
      FormsModule, 
      ReactiveFormsModule,
      MatButtonModule,
      MatIconModule
    ],
    templateUrl: './module-payment.component.html',
    styleUrl: './module-payment.component.scss',
    providers: [TranslocoPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ModulePaymentComponent implements OnInit{
  user: any;
constructor(private gridService: GridService, private authService: AuthService, private translocoPipe: TranslocoPipe, private paymentUtilitiesService:PaymentUtilitiesService,private router: Router, private http: HttpClient) {
  this.user = this.authService.user;
  merge(this.email.statusChanges, this.email.valueChanges)
  .pipe(takeUntilDestroyed())
  .subscribe(() => this.updateErrorMessage());
}
  readonly email = new FormControl('', [Validators.required, Validators.email]);
  errorMessage = signal('');
  hide = signal(true);

  public deleteIcon: string = "trash";
  public deleteSVG: SVGIcon = trashIcon;
  protected somma: number=0;

  
  @ViewChild('paymentRef', {static: true}) paymentRef!: ElementRef;


  ngOnInit(): void {
    console.log("user",this.user);
    
    this.somma = this.storeAmount(this.cart);
    console.log("sommissima",this.somma);
  
  }
 
 get cart(): Module[] {    
 return this.paymentUtilitiesService.cart;
} 

  

  //Funzione per formattare il prezzo
  protected priceFormatter(price:number):string{
    return this.paymentUtilitiesService.priceFormatter(price)
  }

  protected storeAmount(cart: Module[]):number{
    this.somma = this.paymentUtilitiesService.storeAmount(cart);
    return this.somma;
  }

  //elimina il modulo dal carrello
  protected removeModule(id:string):Module[]{
    return this.paymentUtilitiesService.removeModule(id);
  }

 //pulsante per tornare alla pagina precedente(moduli), non perdi il carrello
  protected goToModulePayment(){
    this.router.navigate(['/module-management']);
  }

  updateErrorMessage() {
    if (this.email.hasError('required')) {
      this.errorMessage.set('You must enter a value');
    } else if (this.email.hasError('email')) {
      this.errorMessage.set('Not a valid email');
    } else {
      this.errorMessage.set('');
    }
  }
  clickEvent(event: MouseEvent) {
    this.hide.set(!this.hide());
    event.stopPropagation();
  }

  //funzione per effettuare il pagamento
  startPayment() {
    const requestData = {
      importo: this.somma * 100, // accetta solo valori in centesimi
    };
  
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': '*/*',
    });
  
    this.http.post(`${environment.apiUrl}api/payments/primo-pagamento`, requestData, {
      headers: headers,
      responseType: 'text'
    }).subscribe(
      async html => {
        const url = URL.createObjectURL(new Blob([html], { type: 'text/html;charset=utf-8' }));
  
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
  
        const codTransInput = doc.querySelector('input[name="codTrans"]') as HTMLInputElement;
        const numContrattoInput = doc.querySelector('input[name="num_contratto"]') as HTMLInputElement;
        const importoInput = doc.querySelector('input[name="importo"]') as HTMLInputElement;
  
        const nexiTransactionCode = codTransInput?.value;
        const numContratto = numContrattoInput?.value;
        const importo = importoInput?.value;
  
        await this.createLicense(numContratto, nexiTransactionCode, importo);
  
      },
      error => {
        console.error("Errore nella chiamata al backend:", error);
      }
    );
  }
  

  //Creazione licenza
  async createLicense(contractNumber: string, nexiTransactionCode: string, importo: string): Promise<void> {
    const license: Licenses = {
      Title: 'Licenza utente prova',
      DomCode: this.user.domCode,
      DateStart: DateTime.now().toISO(),
      DateEnd: undefined,
      UserStatus: 'ATTIVO',
      NexiContractNumber: contractNumber
    };
    
    const data = await firstValueFrom<any>(this.gridService.saveScopeData("LICENSES", "UPSERT", license, false));

    const _idLicense = data.data[0]._id;
    const transactionDate = data.data[0].DateStart.$date;

    console.log("licenza: ", _idLicense, transactionDate, nexiTransactionCode, importo);


    await this.createTransaction(_idLicense, transactionDate, nexiTransactionCode, parseInt(importo));
    await this.addLicenseModules(_idLicense, transactionDate);

  
  }
  
  //creazione transazione
  async createTransaction(licenseCode: string, transactionDate: string, NexiTransactionCode: string, importo: number): Promise<void> {
    ;
    const transaction: Transactions = {
      Title: 'titolo di prova',
      DomCode: this.user.domCode,
      LicenseCode: licenseCode,
      TransactionDate: transactionDate,
      TransactionAmount: importo,
      PaymentType: 'PT00000001',
      DiscountCode: 'DCD00000001',
      NexiTransactionCode: NexiTransactionCode,
      Description: 'descrizion di provaDC',
    };

    ;

    const data = await firstValueFrom(this.gridService.saveScopeData("TRANSACTIONS", "UPSERT", transaction, false));

    console.log(data);
    ;
  }

  //creazione record tabella ponte LICENSEMODULES
  async addLicenseModules(licenseCode: string, transactionDate: string): Promise<void> {
    ;
    for(var i=0; i<this.cart.length; i++){

    const moduleCode = this.cart[i].id;
    const planCode = this.cart[i].idPlans;
    
    const licenseModules: LicenseModules = {
      Title: 'titolo di prova',
      DomCode: this.user.domCode,
      LicenseCode: licenseCode,
      ModuleCode: moduleCode,
      DateStart: transactionDate,
      DateEnd: null,
      PlanCode: planCode,
      DateExpired: null
    };

    console.log(licenseModules);
    
    await firstValueFrom(this.gridService.saveScopeData("LICENSEMODULES", "UPSERT", licenseModules, false));
    
  }
  }
  
}
